const translations = {
  en: {
    dir: 'ltr',
    nav: {
      features: 'Features',
      delivery: 'Delivery',
      pricing: 'Pricing',
      howItWorks: 'How It Works',
      getStarted: 'Get Started',
    },
    hero: {
      badge: '🚀 Trusted by 500+ merchants in Tunisia',
      title: 'Your Store.',
      titleHighlight: 'Your Success.',
      subtitle: 'Launch a professional e-commerce store in under 3 minutes. No coding. No hassle. Just sell.',
      cta: 'Start Selling Today',
      ctaSecondary: 'Watch Demo',
      stat1: 'Active Stores',
      stat2: 'Orders Delivered',
      stat3: 'Uptime',
      dashboard: {
        revenue: 'Revenue',
        thisMonth: 'This month',
        orders: 'Orders',
        delivered: 'Delivered',
        newOrder: 'New Order!',
        orderNumber: 'Order #1247',
      },
    },
    features: {
      badge: 'POWERFUL FEATURES',
      title: 'Everything you need to',
      titleHighlight: 'dominate online sales',
      subtitle: 'From product management to delivery tracking, YouShop gives you enterprise-level tools at startup prices.',
      items: [
        {
          icon: '🏪',
          title: 'Professional Storefront',
          desc: 'Beautiful, mobile-first store with custom domain, colors, and branding. Your store looks like a million dollars.',
        },
        {
          icon: '📦',
          title: 'Smart Inventory',
          desc: 'Track stock in real-time, manage variants, SKUs, and never oversell again with intelligent alerts.',
        },
        {
          icon: '🚚',
          title: '4 Delivery Partners',
          desc: 'Integrated with Navex, ADEX, Insta & JAX. Automatic dispatch and barcode tracking.',
        },
        {
          icon: '📊',
          title: 'Analytics Dashboard',
          desc: 'Real-time sales analytics, customer insights, and revenue tracking. Make data-driven decisions.',
        },
        {
          icon: '🎯',
          title: 'Facebook Pixel & Ads',
          desc: 'Built-in Facebook Pixel, Conversion API, and SEO optimization to maximize your marketing ROI.',
        },
        {
          icon: '🔒',
          title: 'SSL & Security',
          desc: 'Free SSL certificates, secure checkout, and enterprise-grade infrastructure. Your customers shop safely.',
        },
      ],
    },
    delivery: {
      badge: 'DELIVERY NETWORK',
      title: 'Nationwide delivery with',
      titleHighlight: 'trusted partners',
      subtitle: 'We partner with Tunisia\'s top delivery companies to ensure your products reach customers fast and safe across all 24 governorates.',
      coverage: 'Covering all 24 Tunisian governorates',
      governoratesCovered: 'Governorates Covered',
      moreCities: '+18 more',
      partners: [
        { name: 'Navex', desc: 'Reliable scheduled deliveries' },
        { name: 'ADEX', desc: 'Premium courier service' },
        { name: 'Insta', desc: 'Postal & light parcels' },
        { name: 'JAX', desc: 'Regional express shipping' },
      ],
      features: [
        'Automatic dispatch & tracking',
        'Barcode scanning integration',
        'Real-time delivery status',
        'Cash on delivery support',
        'Free delivery campaigns',
        'Return management',
      ],
    },
    howItWorks: {
      badge: 'SIMPLE PROCESS',
      title: 'Go live in',
      titleHighlight: '3 minutes',
      subtitle: 'No technical skills needed. We handle the infrastructure, you focus on selling.',
      steps: [
        {
          number: '01',
          title: 'Choose Your Plan',
          desc: 'Subscribe to our monthly plan — simple and affordable.',
        },
        {
          number: '02',
          title: 'Setup Your Store',
          desc: 'Enter your business details, upload your logo, and pick your colors.',
        },
        {
          number: '03',
          title: 'Add Products',
          desc: 'Upload your products with images, prices, variants, and descriptions.',
        },
        {
          number: '04',
          title: 'Start Selling',
          desc: 'Your store is live! Share your link and start receiving orders.',
        },
      ],
    },
    pricing: {
      badge: 'PRICING',
      title: 'Simple, transparent',
      titleHighlight: 'pricing',
      subtitle: 'No hidden fees. No commissions on sales. Just a flat monthly fee.',
      plan: {
        name: 'Professional Store',
        pricingCta: 'Fill the form to become a client and get the pricing',
        desc: 'Everything you need to sell online successfully',
        features: [
          'Professional storefront',
          'Custom subdomain (yourstore.youshop.pro)',
          'Unlimited products',
          'Order management',
          '4 delivery partners integrated',
          'Free SSL certificate',
          'Mobile responsive design',
          'Analytics & reports',
          'Facebook Pixel & Conversion API',
          'Promo codes & campaigns',
          'Supplier management',
          'Priority support',
        ],
        cta: 'Get Started Now',
      },
    },
    inscription: {
      back: 'Back to home',
      badge: 'REGISTRATION',
      title: 'Watch how it works &',
      titleHighlight: 'register now',
      subtitle: 'See YouShop in action, then fill out the form below to launch your store.',
    },
    form: {
      badge: 'GET STARTED',
      title: 'Launch your store',
      titleHighlight: 'today',
      subtitle: 'Fill in your business details and we\'ll have your store ready in minutes.',
      fields: {
        storeName: 'Store Name (اسم المتجر)',
        storeNamePlaceholder: 'e.g., MyBrand',
        firstName: 'First Name (الاسم الأول)',
        firstNamePlaceholder: 'Your first name',
        lastName: 'Last Name (اللقب)',
        lastNamePlaceholder: 'Your last name',
        email: 'Email Address (البريد الإلكتروني)',
        emailPlaceholder: 'contact@yourbusiness.com',
        phone: 'Phone Number (رقم الهاتف)',
        phonePlaceholder: '+216 XX XXX XXX',
        address: 'Business Address (عنوان العمل)',
        addressPlaceholder: 'Your business address',
      },
      benefits: [
        'Store ready in under 3 minutes',
        'Free SSL certificate included',
        'Mobile-optimized storefront',
        '4 delivery partners pre-integrated',
        'No setup fees, cancel anytime',
      ],
      paymentPlan: {
        label: 'Payment Method',
        monthly: '99 TND / month',
        monthlyDesc: 'Fixed monthly subscription',
      },
      fullName: 'Full Name',
      fullNamePlaceholder: 'Your full name',
      facebookPage: 'Facebook Page Name',
      facebookPagePlaceholder: 'e.g: My Store Tunisia',
      submit: 'Create My Store',
      submitting: 'Creating...',
      phoneReassurance: 'Free, no commitment — we call you to activate your store.',
      terms: 'By submitting, you agree to our Terms of Service and Privacy Policy.',
      success: 'Your store request has been submitted! We\'ll contact you within 24 hours.',
    },
    legal: {
      back: 'Back to home',
      badge: 'LEGAL',
      lastUpdated: 'Last updated: October 22, 2026',
      contactTitle: 'Contact us',
      contactDesc: 'If you have any questions about this policy or your personal data, contact us at:',
      privacy: {
        title: 'Privacy Policy',
        intro: 'This Privacy Policy explains how YouShop ("we", "us") collects, uses, shares and protects your personal information when you visit youshop.pro, register for our e-commerce platform, or connect your Facebook account to YouShop.',
        sections: [
          {
            title: 'Information we collect',
            items: [
              { label: 'Information you give us.', text: 'When you fill in our registration form, we collect your store name, first and last name, email address, phone number, business address and Facebook Page name.' },
              { label: 'Information from Facebook.', text: 'If you log in with Facebook or connect your Facebook Page, Pixel or ad account to YouShop, we receive only the information you choose to share, such as your name, email address, profile picture, the Pages you manage and the access tokens needed to provide the features you enable.' },
              { label: 'Usage information.', text: 'Our website uses the Meta Pixel, which collects information about your visit, such as the pages you view, your browser and device type, and your IP address.' },
            ],
          },
          {
            title: 'How we use your information',
            items: [
              'Create, set up and manage your store and account.',
              'Contact you by phone or email about your registration and provide customer support.',
              'Provide the Facebook features you enable, such as Facebook Pixel and Conversions API integration for your store.',
              'Measure the performance of our advertising and improve our services.',
              'Comply with our legal obligations.',
            ],
          },
          {
            title: 'How we share your information',
            body: ['We do not sell your personal information. We only share it with:'],
            items: [
              'Service providers that help us run YouShop, such as hosting providers, who are bound by confidentiality obligations.',
              'Our delivery partners (Navex, ADEX, Insta and JAX), and only the information needed to ship the orders you send through them.',
              'Meta Platforms, through the Meta Pixel and the Facebook features you choose to connect.',
              'Public authorities, when required by law.',
            ],
          },
          {
            title: 'Data received from Facebook',
            body: [
              'We use the data we receive from Facebook only to provide the features you have enabled in YouShop. We do not sell it, use it for unrelated purposes, or share it with anyone except as needed to provide our service or when required by law.',
              'You can remove YouShop\'s access to your Facebook account at any time from your Facebook settings, under Settings & Privacy › Settings › Apps and Websites.',
            ],
          },
          {
            title: 'Data retention',
            body: ['We keep your personal information for as long as your account is active or as long as needed to provide our services. When you close your account or ask us to delete your data, we delete it within 30 days, except for information we must keep by law (such as invoices), which we keep only for the legally required period.'],
          },
          {
            title: 'Security',
            body: ['We protect your information with SSL/TLS encryption, restricted access and secure infrastructure. No method of transmission or storage is 100% secure, but we work hard to protect your data.'],
          },
          {
            title: 'Cookies',
            body: ['We and Meta use cookies and similar technologies to measure our advertising. You can block or delete cookies in your browser settings and manage the ads you see in your Facebook ad preferences.'],
          },
          {
            title: 'Your rights',
            body: ['You can ask us at any time to access, correct or delete your personal information, or object to how we use it. To do so, contact us using the details below.'],
            link: { to: '/data-deletion', label: 'How to delete your data' },
          },
          {
            title: 'Children\'s privacy',
            body: ['YouShop is intended for business owners. Our services are not directed to anyone under 18, and we do not knowingly collect their personal information.'],
          },
          {
            title: 'Changes to this policy',
            body: ['We may update this Privacy Policy from time to time. We will post any changes on this page and update the "Last updated" date above.'],
          },
        ],
      },
      dataDeletion: {
        title: 'Data Deletion',
        intro: 'You can ask YouShop to delete the personal data we hold about you at any time, including any data we received from Facebook. Choose one of the options below.',
        sections: [
          {
            title: 'Remove YouShop from your Facebook account',
            body: ['To stop YouShop from accessing your Facebook data:'],
            ordered: true,
            items: [
              'Go to your Facebook account\'s Settings & Privacy, then click Settings.',
              'Open Apps and Websites to see the apps connected to your account.',
              'Find YouShop and click Remove.',
            ],
            note: 'This stops YouShop from receiving new data from Facebook. To also delete the data we already hold, send us a deletion request as described below.',
          },
          {
            title: 'Request deletion of your data',
            body: ['Send us an email with the subject "Data Deletion Request" and include the name, email address or phone number you used with YouShop, and your store name if you have one.'],
            emailSubject: 'Data Deletion Request',
          },
          {
            title: 'What we delete',
            items: [
              'Your account and registration information: name, email address, phone number, business address, store name and Facebook Page name.',
              'All data received from Facebook, including your profile information, Page information and access tokens.',
              'Your store and its content.',
            ],
            note: 'We keep only the information we must retain by law (such as invoices), and only for the legally required period.',
          },
          {
            title: 'How long it takes',
            body: ['We first verify that the request comes from you, then delete your data within 30 days. We will confirm by email once your data has been deleted.'],
            link: { to: '/privacy-policy', label: 'Read our Privacy Policy' },
          },
        ],
      },
    },
    footer: {
      desc: 'The all-in-one e-commerce platform for Tunisian entrepreneurs. Launch, manage, and grow your online store with ease.',
      product: 'Product',
      company: 'Company',
      support: 'Support',
      links: {
        features: 'Features',
        pricing: 'Pricing',
        delivery: 'Delivery Partners',
        about: 'About Us',
        careers: 'Careers',
        blog: 'Blog',
        help: 'Help Center',
        contact: 'Contact Us',
        status: 'System Status',
        privacy: 'Privacy Policy',
        dataDeletion: 'Data Deletion',
      },
      copyright: '© 2024 YouShop. All rights reserved.',
      madeWith: 'Made with ❤️ in Tunisia',
    },
  },
  fr: {
    dir: 'ltr',
    nav: {
      features: 'Fonctionnalités',
      delivery: 'Livraison',
      pricing: 'Tarifs',
      howItWorks: 'Comment ça marche',
      getStarted: 'Commencer',
    },
    hero: {
      badge: '🚀 Plus de 500 marchands en Tunisie nous font confiance',
      title: 'Votre Boutique.',
      titleHighlight: 'Votre Succès.',
      subtitle: 'Lancez une boutique e-commerce professionnelle en moins de 3 minutes. Sans code. Sans stress. Vendez, c\'est tout.',
      cta: 'Commencer à Vendre',
      ctaSecondary: 'Voir la Démo',
      stat1: 'Boutiques Actives',
      stat2: 'Commandes Livrées',
      stat3: 'Disponibilité',
      dashboard: {
        revenue: 'Revenus',
        thisMonth: 'Ce mois',
        orders: 'Commandes',
        delivered: 'Livré',
        newOrder: 'Nouvelle Commande !',
        orderNumber: 'Commande #1247',
      },
    },
    features: {
      badge: 'FONCTIONNALITÉS PUISSANTES',
      title: 'Tout ce qu\'il vous faut pour',
      titleHighlight: 'dominer la vente en ligne',
      subtitle: 'De la gestion des produits au suivi de livraison, YouShop vous offre des outils de niveau entreprise à prix startup.',
      items: [
        {
          icon: '🏪',
          title: 'Vitrine Professionnelle',
          desc: 'Belle boutique responsive avec domaine personnalisé, couleurs et branding. Votre boutique a l\'air d\'un million.',
        },
        {
          icon: '📦',
          title: 'Inventaire Intelligent',
          desc: 'Suivez le stock en temps réel, gérez les variantes, SKUs, et ne survendez plus jamais.',
        },
        {
          icon: '🚚',
          title: '4 Partenaires Livraison',
          desc: 'Intégré avec Navex, ADEX, Insta & JAX. Dispatch automatique et suivi par code-barres.',
        },
        {
          icon: '📊',
          title: 'Tableau de Bord Analytique',
          desc: 'Analyses de ventes en temps réel, insights clients, et suivi des revenus.',
        },
        {
          icon: '🎯',
          title: 'Facebook Pixel & Pub',
          desc: 'Pixel Facebook intégré, API Conversion, et optimisation SEO pour maximiser votre ROI.',
        },
        {
          icon: '🔒',
          title: 'SSL & Sécurité',
          desc: 'Certificats SSL gratuits, paiement sécurisé, et infrastructure de niveau entreprise.',
        },
      ],
    },
    delivery: {
      badge: 'RÉSEAU DE LIVRAISON',
      title: 'Livraison nationale avec des',
      titleHighlight: 'partenaires de confiance',
      subtitle: 'Nous travaillons avec les meilleures entreprises de livraison en Tunisie pour garantir que vos produits arrivent rapidement et en sécurité dans les 24 gouvernorats.',
      coverage: 'Couverture des 24 gouvernorats tunisiens',
      governoratesCovered: 'Gouvernorats Couverts',
      moreCities: '+18 de plus',
      partners: [
        { name: 'Navex', desc: 'Livraisons programmées fiables' },
        { name: 'ADEX', desc: 'Service coursier premium' },
        { name: 'Insta', desc: 'Postal & colis légers' },
        { name: 'JAX', desc: 'Expédition express régionale' },
      ],
      features: [
        'Dispatch & suivi automatique',
        'Intégration scan code-barres',
        'Statut de livraison en temps réel',
        'Paiement à la livraison',
        'Campagnes livraison gratuite',
        'Gestion des retours',
      ],
    },
    howItWorks: {
      badge: 'PROCESSUS SIMPLE',
      title: 'En ligne en',
      titleHighlight: '3 minutes',
      subtitle: 'Aucune compétence technique requise. Nous gérons l\'infrastructure, vous vous concentrez sur la vente.',
      steps: [
        {
          number: '01',
          title: 'Choisissez Votre Plan',
          desc: 'Abonnez-vous à notre offre mensuelle — simple et abordable.',
        },
        {
          number: '02',
          title: 'Configurez Votre Boutique',
          desc: 'Entrez vos infos, uploadez votre logo, choisissez vos couleurs.',
        },
        {
          number: '03',
          title: 'Ajoutez Vos Produits',
          desc: 'Uploadez vos produits avec images, prix, variantes et descriptions.',
        },
        {
          number: '04',
          title: 'Commencez à Vendre',
          desc: 'Votre boutique est en ligne ! Partagez votre lien et recevez des commandes.',
        },
      ],
    },
    pricing: {
      badge: 'TARIFS',
      title: 'Des tarifs simples et',
      titleHighlight: 'transparents',
      subtitle: 'Pas de frais cachés. Pas de commissions sur les ventes. Juste un abonnement mensuel fixe.',
      plan: {
        name: 'Boutique Professionnelle',
        pricingCta: 'Remplissez le formulaire pour devenir client et obtenir les tarifs',
        desc: 'Tout ce qu\'il vous faut pour vendre en ligne avec succès',
        features: [
          'Vitrine professionnelle',
          'Sous-domaine personnalisé (votreboutique.youshop.pro)',
          'Produits illimités',
          'Gestion des commandes',
          '4 partenaires livraison intégrés',
          'Certificat SSL gratuit',
          'Design responsive mobile',
          'Analyses & rapports',
          'Facebook Pixel & API Conversion',
          'Codes promo & campagnes',
          'Gestion fournisseurs',
          'Support prioritaire',
        ],
        cta: 'Commencer Maintenant',
      },
    },
    inscription: {
      back: 'Retour à l\'accueil',
      badge: 'INSCRIPTION',
      title: 'Découvrez comment ça marche &',
      titleHighlight: 'inscrivez-vous',
      subtitle: 'Regardez YouShop en action, puis remplissez le formulaire ci-dessous pour lancer votre boutique.',
    },
    form: {
      badge: 'COMMENCER',
      title: 'Lancez votre boutique',
      titleHighlight: 'aujourd\'hui',
      subtitle: 'Remplissez vos informations et votre boutique sera prête en quelques minutes.',
      fields: {
        storeName: 'Nom de la Boutique (اسم المتجر)',
        storeNamePlaceholder: 'ex: MaMarque',
        firstName: 'Prénom (الاسم الأول)',
        firstNamePlaceholder: 'Votre prénom',
        lastName: 'Nom (اللقب)',
        lastNamePlaceholder: 'Votre nom de famille',
        email: 'Adresse Email (البريد الإلكتروني)',
        emailPlaceholder: 'contact@votreentreprise.com',
        phone: 'Numéro de Téléphone (رقم الهاتف)',
        phonePlaceholder: '+216 XX XXX XXX',
        address: 'Adresse Professionnelle (عنوان العمل)',
        addressPlaceholder: 'Votre adresse professionnelle',
      },
      benefits: [
        'Boutique prête en moins de 3 minutes',
        'Certificat SSL gratuit inclus',
        'Vitrine optimisée mobile',
        '4 partenaires livraison pré-intégrés',
        "Sans frais d'installation, annulez quand vous voulez",
      ],
      paymentPlan: {
        label: 'Méthode de paiement',
        monthly: '99 TND / mois',
        monthlyDesc: 'Abonnement mensuel fixe',
      },
      fullName: 'Nom complet',
      fullNamePlaceholder: 'Votre nom et prénom',
      facebookPage: 'Nom de la page Facebook',
      facebookPagePlaceholder: 'ex: Mon Magasin Tunisie',
      submit: 'Créer Ma Boutique',
      submitting: 'Création...',
      phoneReassurance: 'Gratuit, sans engagement — on vous appelle pour activer votre boutique.',
      terms: "En soumettant, vous acceptez nos Conditions d'Utilisation et Politique de Confidentialité.",
      success: 'Votre demande a été soumise ! Nous vous contacterons dans les 24 heures.',
    },
    legal: {
      back: 'Retour à l\'accueil',
      badge: 'LÉGAL',
      lastUpdated: 'Dernière mise à jour : 22 octobre 2026',
      contactTitle: 'Nous contacter',
      contactDesc: 'Pour toute question concernant cette politique ou vos données personnelles, contactez-nous à :',
      privacy: {
        title: 'Politique de Confidentialité',
        intro: 'Cette Politique de Confidentialité explique comment YouShop (« nous ») collecte, utilise, partage et protège vos données personnelles lorsque vous visitez youshop.pro, vous inscrivez sur notre plateforme e-commerce ou connectez votre compte Facebook à YouShop.',
        sections: [
          {
            title: 'Données que nous collectons',
            items: [
              { label: 'Données que vous nous fournissez.', text: 'Lorsque vous remplissez notre formulaire d\'inscription, nous collectons le nom de votre boutique, vos nom et prénom, votre adresse e-mail, votre numéro de téléphone, votre adresse professionnelle et le nom de votre page Facebook.' },
              { label: 'Données provenant de Facebook.', text: 'Si vous vous connectez avec Facebook ou connectez votre page Facebook, votre Pixel ou votre compte publicitaire à YouShop, nous recevons uniquement les informations que vous choisissez de partager, comme votre nom, votre adresse e-mail, votre photo de profil, les pages que vous gérez et les jetons d\'accès nécessaires aux fonctionnalités que vous activez.' },
              { label: 'Données d\'utilisation.', text: 'Notre site utilise le Pixel Meta, qui collecte des informations sur votre visite, comme les pages consultées, votre type de navigateur et d\'appareil, et votre adresse IP.' },
            ],
          },
          {
            title: 'Utilisation de vos données',
            items: [
              'Créer, configurer et gérer votre boutique et votre compte.',
              'Vous contacter par téléphone ou e-mail au sujet de votre inscription et vous apporter un support client.',
              'Fournir les fonctionnalités Facebook que vous activez, comme l\'intégration du Pixel Facebook et de l\'API Conversions pour votre boutique.',
              'Mesurer la performance de nos publicités et améliorer nos services.',
              'Respecter nos obligations légales.',
            ],
          },
          {
            title: 'Partage de vos données',
            body: ['Nous ne vendons pas vos données personnelles. Nous les partageons uniquement avec :'],
            items: [
              'Les prestataires qui nous aident à faire fonctionner YouShop, comme nos hébergeurs, soumis à des obligations de confidentialité.',
              'Nos partenaires de livraison (Navex, ADEX, Insta et JAX), uniquement pour les informations nécessaires à l\'expédition des commandes que vous leur confiez.',
              'Meta Platforms, via le Pixel Meta et les fonctionnalités Facebook que vous choisissez de connecter.',
              'Les autorités publiques, lorsque la loi l\'exige.',
            ],
          },
          {
            title: 'Données reçues de Facebook',
            body: [
              'Nous utilisons les données reçues de Facebook uniquement pour fournir les fonctionnalités que vous avez activées dans YouShop. Nous ne les vendons pas, ne les utilisons pas à d\'autres fins et ne les partageons avec personne, sauf si cela est nécessaire pour fournir notre service ou si la loi l\'exige.',
              'Vous pouvez retirer à tout moment l\'accès de YouShop à votre compte Facebook depuis vos paramètres Facebook, dans Paramètres et confidentialité › Paramètres › Apps et sites web.',
            ],
          },
          {
            title: 'Conservation des données',
            body: ['Nous conservons vos données personnelles tant que votre compte est actif ou aussi longtemps que nécessaire pour fournir nos services. Lorsque vous fermez votre compte ou nous demandez de supprimer vos données, nous les supprimons dans un délai de 30 jours, à l\'exception des informations que la loi nous oblige à conserver (comme les factures), conservées uniquement pendant la durée légale.'],
          },
          {
            title: 'Sécurité',
            body: ['Nous protégeons vos données grâce au chiffrement SSL/TLS, à un accès restreint et à une infrastructure sécurisée. Aucune méthode de transmission ou de stockage n\'est sûre à 100 %, mais nous faisons tout notre possible pour protéger vos données.'],
          },
          {
            title: 'Cookies',
            body: ['Meta et nous utilisons des cookies et des technologies similaires pour mesurer nos publicités. Vous pouvez bloquer ou supprimer les cookies dans les paramètres de votre navigateur et gérer les publicités que vous voyez dans vos préférences publicitaires Facebook.'],
          },
          {
            title: 'Vos droits',
            body: ['Vous pouvez à tout moment nous demander d\'accéder à vos données personnelles, de les rectifier ou de les supprimer, ou vous opposer à leur utilisation. Pour cela, contactez-nous via les coordonnées ci-dessous.'],
            link: { to: '/data-deletion', label: 'Comment supprimer vos données' },
          },
          {
            title: 'Protection des mineurs',
            body: ['YouShop s\'adresse aux professionnels. Nos services ne sont pas destinés aux personnes de moins de 18 ans et nous ne collectons pas sciemment leurs données personnelles.'],
          },
          {
            title: 'Modifications de cette politique',
            body: ['Nous pouvons mettre à jour cette Politique de Confidentialité de temps à autre. Toute modification sera publiée sur cette page avec une nouvelle date de « Dernière mise à jour ».'],
          },
        ],
      },
      dataDeletion: {
        title: 'Suppression des Données',
        intro: 'Vous pouvez à tout moment demander à YouShop de supprimer les données personnelles que nous détenons sur vous, y compris celles reçues de Facebook. Choisissez l\'une des options ci-dessous.',
        sections: [
          {
            title: 'Retirer YouShop de votre compte Facebook',
            body: ['Pour empêcher YouShop d\'accéder à vos données Facebook :'],
            ordered: true,
            items: [
              'Allez dans Paramètres et confidentialité de votre compte Facebook, puis cliquez sur Paramètres.',
              'Ouvrez Apps et sites web pour voir les applications connectées à votre compte.',
              'Trouvez YouShop et cliquez sur Supprimer.',
            ],
            note: 'YouShop ne recevra alors plus de nouvelles données de Facebook. Pour supprimer également les données que nous détenons déjà, envoyez-nous une demande de suppression comme décrit ci-dessous.',
          },
          {
            title: 'Demander la suppression de vos données',
            body: ['Envoyez-nous un e-mail avec l\'objet « Demande de suppression des données » en indiquant le nom, l\'adresse e-mail ou le numéro de téléphone utilisé sur YouShop, ainsi que le nom de votre boutique si vous en avez une.'],
            emailSubject: 'Demande de suppression des données',
          },
          {
            title: 'Ce que nous supprimons',
            items: [
              'Les informations de votre compte et de votre inscription : nom, adresse e-mail, numéro de téléphone, adresse professionnelle, nom de la boutique et nom de la page Facebook.',
              'Toutes les données reçues de Facebook, y compris les informations de votre profil, de vos pages et vos jetons d\'accès.',
              'Votre boutique et son contenu.',
            ],
            note: 'Nous conservons uniquement les informations que la loi nous oblige à garder (comme les factures), et seulement pendant la durée légale.',
          },
          {
            title: 'Délai de traitement',
            body: ['Nous vérifions d\'abord que la demande vient bien de vous, puis nous supprimons vos données dans un délai de 30 jours. Nous vous confirmerons la suppression par e-mail.'],
            link: { to: '/privacy-policy', label: 'Lire notre Politique de Confidentialité' },
          },
        ],
      },
    },
    footer: {
      desc: 'La plateforme e-commerce tout-en-un pour les entrepreneurs tunisiens. Lancez, gérez et développez votre boutique en ligne facilement.',
      product: 'Produit',
      company: 'Entreprise',
      support: 'Support',
      links: {
        features: 'Fonctionnalités',
        pricing: 'Tarifs',
        delivery: 'Partenaires Livraison',
        about: 'À Propos',
        careers: 'Carrières',
        blog: 'Blog',
        help: 'Centre d\'Aide',
        contact: 'Nous Contacter',
        status: 'État du Système',
        privacy: 'Politique de Confidentialité',
        dataDeletion: 'Suppression des Données',
      },
      copyright: '© 2024 YouShop. Tous droits réservés.',
      madeWith: 'Fait avec ❤️ en Tunisie',
    },
  },
  ar: {
    dir: 'rtl',
    nav: {
      features: 'المميزات',
      delivery: 'التوصيل',
      pricing: 'الأسعار',
      howItWorks: 'كيف يعمل',
      getStarted: 'ابدأ الآن',
    },
    hero: {
      badge: '🚀 أكثر من 500 تاجر في تونس يثقون بنا',
      title: 'متجرك.',
      titleHighlight: 'نجاحك.',
      subtitle: 'أطلق متجرك الإلكتروني المحترف في أقل من 3 دقائق. بدون برمجة. بدون تعقيد. فقط بيع.',
      cta: 'ابدأ البيع اليوم',
      ctaSecondary: 'شاهد العرض',
      stat1: 'متاجر نشطة',
      stat2: 'طلبات تم توصيلها',
      stat3: 'وقت التشغيل',
      dashboard: {
        revenue: 'الإيرادات',
        thisMonth: 'هذا الشهر',
        orders: 'الطلبات',
        delivered: 'تم التوصيل',
        newOrder: 'طلب جديد!',
        orderNumber: 'طلب #1247',
      },
    },
    features: {
      badge: 'مميزات قوية',
      title: 'كل ما تحتاجه',
      titleHighlight: 'للسيطرة على البيع الإلكتروني',
      subtitle: 'من إدارة المنتجات إلى تتبع التوصيل، YouShop يمنحك أدوات مؤسسية بأسعار ناشئة.',
      items: [
        {
          icon: '🏪',
          title: 'واجهة متجر احترافية',
          desc: 'متجر جميل ومتجاوب مع نطاق مخصص وألوان وعلامة تجارية. متجرك يبدو بمليون دولار.',
        },
        {
          icon: '📦',
          title: 'مخزون ذكي',
          desc: 'تتبع المخزون في الوقت الفعلي، إدارة المتغيرات والـ SKU، ولا تبيع أكثر من المتاح.',
        },
        {
          icon: '🚚',
          title: '4 شركاء توصيل',
          desc: 'متكامل مع Navex و ADEX و Insta و JAX. إرسال تلقائي وتتبع بالباركود.',
        },
        {
          icon: '📊',
          title: 'لوحة تحليلات',
          desc: 'تحليلات مبيعات فورية، رؤى العملاء، وتتبع الإيرادات. اتخذ قرارات مبنية على البيانات.',
        },
        {
          icon: '🎯',
          title: 'فيسبوك بيكسل وإعلانات',
          desc: 'بيكسل فيسبوك مدمج، API التحويلات، وتحسين SEO لتعظيم عائد إعلاناتك.',
        },
        {
          icon: '🔒',
          title: 'SSL والأمان',
          desc: 'شهادات SSL مجانية، دفع آمن، وبنية تحتية مؤسسية. عملاؤك يتسوقون بأمان.',
        },
      ],
    },
    delivery: {
      badge: 'شبكة التوصيل',
      title: 'توصيل وطني مع',
      titleHighlight: 'شركاء موثوقين',
      subtitle: 'نتعاون مع أفضل شركات التوصيل في تونس لضمان وصول منتجاتك بسرعة وأمان عبر الـ 24 ولاية.',
      coverage: 'تغطية جميع الولايات التونسية الـ 24',
      governoratesCovered: 'الولايات المغطّاة',
      moreCities: '+18 أخرى',
      partners: [
        { name: 'Navex', desc: 'توصيلات مجدولة موثوقة' },
        { name: 'ADEX', desc: 'خدمة بريد سريع ممتازة' },
        { name: 'Insta', desc: 'بريد وطرود خفيفة' },
        { name: 'JAX', desc: 'شحن سريع إقليمي' },
      ],
      features: [
        'إرسال وتتبع تلقائي',
        'تكامل مسح الباركود',
        'حالة التوصيل في الوقت الفعلي',
        'الدفع عند الاستلام',
        'حملات التوصيل المجاني',
        'إدارة المرتجعات',
      ],
    },
    howItWorks: {
      badge: 'عملية بسيطة',
      title: 'انطلق في',
      titleHighlight: '3 دقائق',
      subtitle: 'لا حاجة لمهارات تقنية. نحن نتولى البنية التحتية، أنت ركز على البيع.',
      steps: [
        {
          number: '01',
          title: 'اختر خطتك',
          desc: 'اشترك في عرضنا الشهري — بسيط وميسور.',
        },
        {
          number: '02',
          title: 'أعد متجرك',
          desc: 'أدخل تفاصيل عملك، ارفع شعارك، واختر ألوانك.',
        },
        {
          number: '03',
          title: 'أضف منتجاتك',
          desc: 'ارفع منتجاتك مع الصور والأسعار والمتغيرات والأوصاف.',
        },
        {
          number: '04',
          title: 'ابدأ البيع',
          desc: 'متجرك مباشر! شارك رابطك وابدأ في استقبال الطلبات.',
        },
      ],
    },
    pricing: {
      badge: 'الأسعار',
      title: 'أسعار بسيطة',
      titleHighlight: 'وشفافة',
      subtitle: 'لا رسوم مخفية. لا عمولات على المبيعات. فقط اشتراك شهري ثابت.',
      plan: {
        name: 'متجر احترافي',
        pricingCta: 'املأ النموذج لتصبح عميلاً واحصل على الأسعار',
        desc: 'كل ما تحتاجه للبيع عبر الإنترنت بنجاح',
        features: [
          'واجهة متجر احترافية',
          'نطاق فرعي مخصص (متجرك.youshop.pro)',
          'منتجات غير محدودة',
          'إدارة الطلبات',
          '4 شركاء توصيل متكاملين',
          'شهادة SSL مجانية',
          'تصميم متجاوب مع الهاتف',
          'تحليلات وتقارير',
          'فيسبوك بيكسل و API التحويلات',
          'أكواد ترويجية وحملات',
          'إدارة الموردين',
          'دعم أولوي',
        ],
        cta: 'ابدأ الآن',
      },
    },
    inscription: {
      back: 'العودة للرئيسية',
      badge: 'التسجيل',
      title: 'شاهد كيف يعمل &',
      titleHighlight: 'سجّل الآن',
      subtitle: 'شاهد يو شوب أثناء العمل، ثم املأ النموذج أدناه لإطلاق متجرك.',
    },
    form: {
      badge: 'ابدأ الآن',
      title: 'أطلق متجرك',
      titleHighlight: 'اليوم',
      subtitle: 'املأ تفاصيل عملك وسيكون متجرك جاهزاً في دقائق.',
      fields: {
        storeName: 'اسم المتجر',
        storeNamePlaceholder: 'مثال: علامتي',
        firstName: 'الاسم الأول',
        firstNamePlaceholder: 'اسمك الأول',
        lastName: 'اللقب',
        lastNamePlaceholder: 'لقبك',
        email: 'البريد الإلكتروني',
        emailPlaceholder: 'contact@yourbusiness.com',
        phone: 'رقم الهاتف',
        phonePlaceholder: '+216 XX XXX XXX',
        address: 'عنوان العمل',
        addressPlaceholder: 'عنوان عملك',
      },
      benefits: [
        'متجر جاهز في أقل من 3 دقائق',
        'شهادة SSL مجانية مضمّنة',
        'واجهة متجر محسّنة للهاتف',
        '4 شركاء توصيل مدمجون',
        'بدون رسوم إعداد، ألغِ متى شئت',
      ],
      paymentPlan: {
        label: 'طريقة الدفع',
        monthly: '99 TND / شهر',
        monthlyDesc: 'اشتراك شهري ثابت',
      },
      fullName: 'الاسم الكامل',
      fullNamePlaceholder: 'الاسم واللقب',
      facebookPage: 'اسم صفحة فيسبوك',
      facebookPagePlaceholder: 'مثال: متجري تونس',
      submit: 'أنشئ متجري',
      submitting: 'جاري الإنشاء...',
      phoneReassurance: 'مجاناً وبدون التزام — نتصل بك لتفعيل متجرك.',
      terms: 'بالإرسال، أنت توافق على شروط الخدمة وسياسة الخصوصية.',
      success: 'تم إرسال طلبك! سنتواصل معك خلال 24 ساعة.',
    },
    legal: {
      back: 'العودة للرئيسية',
      badge: 'قانوني',
      lastUpdated: 'آخر تحديث: 22 أكتوبر 2026',
      contactTitle: 'اتصل بنا',
      contactDesc: 'لأي سؤال حول هذه السياسة أو بياناتك الشخصية، راسلنا على:',
      privacy: {
        title: 'سياسة الخصوصية',
        intro: 'توضح سياسة الخصوصية هذه كيف تقوم YouShop ("نحن") بجمع بياناتك الشخصية واستخدامها ومشاركتها وحمايتها عند زيارتك لموقع youshop.pro أو تسجيلك في منصتنا للتجارة الإلكترونية أو ربط حسابك على فيسبوك بـ YouShop.',
        sections: [
          {
            title: 'البيانات التي نجمعها',
            items: [
              { label: 'البيانات التي تقدمها لنا.', text: 'عند ملء استمارة التسجيل، نجمع اسم متجرك واسمك ولقبك وبريدك الإلكتروني ورقم هاتفك وعنوان عملك واسم صفحتك على فيسبوك.' },
              { label: 'البيانات الواردة من فيسبوك.', text: 'إذا سجلت الدخول عبر فيسبوك أو ربطت صفحتك على فيسبوك أو البكسل أو حسابك الإعلاني بـ YouShop، فإننا نتلقى فقط المعلومات التي تختار مشاركتها، مثل اسمك وبريدك الإلكتروني وصورة ملفك الشخصي والصفحات التي تديرها ورموز الوصول اللازمة لتقديم الميزات التي تفعّلها.' },
              { label: 'بيانات الاستخدام.', text: 'يستخدم موقعنا بكسل ميتا (Meta Pixel) الذي يجمع معلومات حول زيارتك، مثل الصفحات التي تتصفحها ونوع المتصفح والجهاز وعنوان IP الخاص بك.' },
            ],
          },
          {
            title: 'كيف نستخدم بياناتك',
            items: [
              'إنشاء متجرك وحسابك وإعدادهما وإدارتهما.',
              'التواصل معك عبر الهاتف أو البريد الإلكتروني بخصوص تسجيلك وتقديم الدعم لك.',
              'تقديم ميزات فيسبوك التي تفعّلها، مثل ربط بكسل فيسبوك وواجهة Conversions API بمتجرك.',
              'قياس أداء إعلاناتنا وتحسين خدماتنا.',
              'الامتثال لالتزاماتنا القانونية.',
            ],
          },
          {
            title: 'مشاركة بياناتك',
            body: ['نحن لا نبيع بياناتك الشخصية، ولا نشاركها إلا مع:'],
            items: [
              'مزودي الخدمات الذين يساعدوننا في تشغيل YouShop، مثل مزودي الاستضافة، والملتزمين بواجب السرية.',
              'شركاء التوصيل (Navex وADEX وInsta وJAX)، وذلك فقط بالمعلومات اللازمة لشحن الطلبات التي ترسلها عبرهم.',
              'شركة Meta Platforms، عبر بكسل ميتا وميزات فيسبوك التي تختار ربطها.',
              'السلطات العمومية عندما يقتضي القانون ذلك.',
            ],
          },
          {
            title: 'البيانات الواردة من فيسبوك',
            body: [
              'نستخدم البيانات التي نتلقاها من فيسبوك فقط لتقديم الميزات التي فعّلتها في YouShop. لا نبيعها ولا نستخدمها لأغراض أخرى ولا نشاركها مع أي طرف إلا عند الحاجة لتقديم خدمتنا أو عندما يقتضي القانون ذلك.',
              'يمكنك في أي وقت إلغاء وصول YouShop إلى حسابك على فيسبوك من إعدادات فيسبوك، ضمن الإعدادات والخصوصية › الإعدادات › التطبيقات ومواقع الويب.',
            ],
          },
          {
            title: 'الاحتفاظ بالبيانات',
            body: ['نحتفظ ببياناتك الشخصية طالما كان حسابك نشطاً أو طوال المدة اللازمة لتقديم خدماتنا. عند إغلاق حسابك أو طلبك حذف بياناتك، نحذفها خلال 30 يوماً، باستثناء المعلومات التي يلزمنا القانون بالاحتفاظ بها (مثل الفواتير)، والتي نحتفظ بها فقط طوال المدة القانونية.'],
          },
          {
            title: 'الأمان',
            body: ['نحمي بياناتك من خلال تشفير SSL/TLS وتقييد الوصول وبنية تحتية آمنة. لا توجد وسيلة نقل أو تخزين آمنة بنسبة 100%، لكننا نبذل قصارى جهدنا لحماية بياناتك.'],
          },
          {
            title: 'ملفات تعريف الارتباط (الكوكيز)',
            body: ['نستخدم نحن وMeta ملفات تعريف الارتباط وتقنيات مماثلة لقياس أداء إعلاناتنا. يمكنك حظر ملفات تعريف الارتباط أو حذفها من إعدادات متصفحك، والتحكم في الإعلانات التي تظهر لك من تفضيلات الإعلانات في فيسبوك.'],
          },
          {
            title: 'حقوقك',
            body: ['يمكنك في أي وقت أن تطلب منا الاطلاع على بياناتك الشخصية أو تصحيحها أو حذفها، أو الاعتراض على طريقة استخدامها. للقيام بذلك، تواصل معنا عبر البيانات أدناه.'],
            link: { to: '/data-deletion', label: 'كيفية حذف بياناتك' },
          },
          {
            title: 'خصوصية القاصرين',
            body: ['YouShop موجهة لأصحاب الأعمال. خدماتنا غير موجهة لمن هم دون 18 عاماً، ولا نجمع بياناتهم الشخصية عن قصد.'],
          },
          {
            title: 'التغييرات على هذه السياسة',
            body: ['قد نقوم بتحديث سياسة الخصوصية هذه من حين لآخر. سننشر أي تغييرات على هذه الصفحة مع تحديث تاريخ "آخر تحديث" أعلاه.'],
          },
        ],
      },
      dataDeletion: {
        title: 'حذف البيانات',
        intro: 'يمكنك في أي وقت أن تطلب من YouShop حذف البيانات الشخصية التي نحتفظ بها عنك، بما في ذلك البيانات التي تلقيناها من فيسبوك. اختر أحد الخيارين أدناه.',
        sections: [
          {
            title: 'إزالة YouShop من حسابك على فيسبوك',
            body: ['لمنع YouShop من الوصول إلى بياناتك على فيسبوك:'],
            ordered: true,
            items: [
              'ادخل إلى الإعدادات والخصوصية في حسابك على فيسبوك، ثم اضغط على الإعدادات.',
              'افتح التطبيقات ومواقع الويب لعرض التطبيقات المرتبطة بحسابك.',
              'ابحث عن YouShop واضغط على إزالة.',
            ],
            note: 'بذلك لن تتلقى YouShop أي بيانات جديدة من فيسبوك. لحذف البيانات التي نحتفظ بها بالفعل، أرسل لنا طلب حذف كما هو موضح أدناه.',
          },
          {
            title: 'طلب حذف بياناتك',
            body: ['أرسل لنا بريداً إلكترونياً بعنوان "طلب حذف البيانات" واذكر فيه الاسم أو البريد الإلكتروني أو رقم الهاتف الذي استخدمته في YouShop، واسم متجرك إن وُجد.'],
            emailSubject: 'طلب حذف البيانات',
          },
          {
            title: 'ما الذي نحذفه',
            items: [
              'معلومات حسابك وتسجيلك: الاسم والبريد الإلكتروني ورقم الهاتف وعنوان العمل واسم المتجر واسم صفحة فيسبوك.',
              'جميع البيانات الواردة من فيسبوك، بما في ذلك معلومات ملفك الشخصي وصفحاتك ورموز الوصول.',
              'متجرك ومحتواه.',
            ],
            note: 'نحتفظ فقط بالمعلومات التي يلزمنا القانون بالاحتفاظ بها (مثل الفواتير)، وذلك طوال المدة القانونية فقط.',
          },
          {
            title: 'مدة المعالجة',
            body: ['نتحقق أولاً من أن الطلب صادر عنك، ثم نحذف بياناتك خلال 30 يوماً، وسنؤكد لك الحذف عبر البريد الإلكتروني.'],
            link: { to: '/privacy-policy', label: 'اطلع على سياسة الخصوصية' },
          },
        ],
      },
    },
    footer: {
      desc: 'منصة التجارة الإلكترونية الشاملة لرواد الأعمال التونسيين. أطلق، أدر، وطوّر متجرك الإلكتروني بسهولة.',
      product: 'المنتج',
      company: 'الشركة',
      support: 'الدعم',
      links: {
        features: 'المميزات',
        pricing: 'الأسعار',
        delivery: 'شركاء التوصيل',
        about: 'من نحن',
        careers: 'الوظائف',
        blog: 'المدونة',
        help: 'مركز المساعدة',
        contact: 'اتصل بنا',
        status: 'حالة النظام',
        privacy: 'سياسة الخصوصية',
        dataDeletion: 'حذف البيانات',
      },
      copyright: '© 2024 YouShop. جميع الحقوق محفوظة.',
      madeWith: 'صنع بـ ❤️ في تونس',
    },
  },
};

export default translations;
